import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Crop icon — two overlapping right angles forming a crop-marker.
 * Uses `stroke="currentColor"` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const CropIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M3.33301 6.66732H12.6663C13.0345 6.66732 13.333 6.96579 13.333 7.33398V16.6673M16.6663 13.334L7.33301 13.334C6.96482 13.334 6.66634 13.0355 6.66634 12.6673L6.66634 3.33398"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default CropIcon;
